import { useState } from 'react';
import { useDebounceCallback, useResizeObserver } from 'usehooks-ts';

// This hook is used to debounce the resize observer callback to avoid
// "ResizeObserver loop completed with undelivered notifications" error as suggested by Copilot.
// See https://github.com/sankeyart/sankeyart/issues/1716.
export const useDebouncedResizeObserverFor = (
  ref: React.RefObject<HTMLElement>,
  debounceMs = 200
) => {
  const [size, setSize] = useState<{ width?: number; height?: number }>();
  const onResize = useDebounceCallback(setSize, debounceMs);
  useResizeObserver({ ref, onResize });
  return { width: size?.width ?? 0, height: size?.height ?? 0 };
};
